

export default {
  name: 'Tax',
  components: {
  },
  props: {},
  data() {
    return {
    };
  },
  computed: {
    getTax() {
      return this.$store.getters['docs/getterTax'];
    },
    getCountry() {
      return this.$i18n.t('tax.country');
    },
    getCountryName() {
      return this.$i18n.t('tax.country_name');
    },
    getVat() {
      return this.$i18n.t('tax.vat');
    },
  },
  created() {
    this.fetchTax();
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    fetchTax() {
      const searchLang = this.$route.query.lang;
      const calculatedLang = searchLang ? searchLang.split('_')[0] : this.$root.$i18n.locale.split('_')[0];
      const locale = calculatedLang === 'ru' ? 'ru' : 'en';
      this.$store.dispatch('docs/fetchTax', { locale });
    },
  },
};
